export const fetchWithTimeout: (url: string) => Promise<Response> = (url: string) => new Promise(async (resolve, reject) => {
  setTimeout(() => reject("Software timeout (15 seconds)"), 15000);
  const response = await fetch(url);
  resolve(response);
})